<template>
  <div class="use-new">
    <b-row>
      <b-col class="text-left" cols="12">
        <b-input-group>
          <b-form-input v-model="searchQuery" placeholder="Tìm kiếm theo từ khóa...."
                        v-on:keydown.enter="quickSearch"/>
          <b-input-group-append is-text role="button" @click="quickSearch">
            <feather-icon icon="SearchIcon"/>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12 mt-50">
        <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :pagination-options="{perPage: serverParams.pageSize,enabled: true,perPageDropdown: [20,50,100],dropdownAllowAll: false}"
                        :rows="listNews" :totalRows="totalRecords" mode="remote"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'name'">
              <span v-title="props.row.contents"
                    :style="[ props.row.isRead ? {opacity: 0.5}: {opacity: 1}]"
                    style="font-weight: bold; color: blue; cursor: pointer; line-height: 30px;" @click="detailClick(props.row)">{{props.row.name}}</span>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </b-col>
    </b-row>
    <!-- chính sách + quy trình quy định -->
    <b-modal id="modal-view-hot" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="use-new">
        <b-col class="view-left mt-50" cols="4">
          <!-- <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Ngày hiệu lực: </label>
                <label class="ml-50"> {{ currentItem.effect_date }}</label>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban chủ trì: </label>
                <label class="ml-50"> {{ currentItem.department_presiding_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban tham gia: </label>
                <label class="ml-50"> {{ currentItem.department_join_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="currentItem.cate_type_new == 0 || currentItem.cate_type_new == 1">
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Người soạn thảo: </label>
                <label class="ml-50"> {{ currentItem.creator_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="currentItem.cate_type_new == 0 || currentItem.cate_type_new == 1">
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Người phê duyệt: </label>
                <label class="ml-50"> {{ currentItem.approver }}</label>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mt-50 border-left" cols="8">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Đối tượng áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_object }}</label>
              </b-form-group>
            </b-col>

            <b-col v-if="currentItem.cat_type_new == 1" cols="12">
              <b-form-group>
                <label class="font-bold">Trường hợp áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_cases }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <!-- eslint-disable vue/no-v-html -->
                <div class="question-content" v-html="currentItem.contents"/>
                <!-- eslint-enable -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                             @click="downloadFile(currentItem.file_path)">
                <div class="sample-file__download">
                  <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                </div>
                {{ currentItem.file_path }}
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <!-- kt chính sách + quy trình -->
    <!-- khuyến mại -->
    <b-modal id="modal-view-hot-promotion" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="use-new">
        <b-col class="view-left mt-50" cols="4">
          <!-- <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Ngày hiệu lực: </label>
                <label class="ml-50"> {{ currentItem.effect_date }}</label>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban chủ trì: </label>
                <label class="ml-50"> {{ currentItem.department_presiding_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban tham gia: </label>
                <label class="ml-50"> {{ currentItem.department_join_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Đối tượng áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_object }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phạm vi áp dụng: </label>
                <label class="ml-50"> {{ currentItem.application_scope }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Hình thức triển khai: </label>
                <label class="ml-50"> {{ currentItem.deployment_form }}</label>
              </b-form-group>
            </b-col>
          </b-row>

        </b-col>
        <b-col class="mt-50 border-left" cols="8">
          <b-row>
            <b-col class="not-padding-r " cols="6">
              <b-form-group class=" margin-b">
                <label class="font-bold">Ngày bắt đầu: </label>
                <label class="ml-50"> {{ currentItem.from_date }}</label>
              </b-form-group>
            </b-col>
            <b-col class="not-padding " cols="6">
              <b-form-group class="border-left margin-b">
                <label class="font-bold" style="padding-left:20px">Ngày kết thúc: </label>
                <label class="ml-50"> {{ currentItem.to_date }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <!-- eslint-disable vue/no-v-html -->
                <div class="question-content" v-html="currentItem.contents"/>
                <!-- eslint-enable -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                             @click="downloadFile(currentItem.file_path)">
                <div class="sample-file__download">
                  <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                </div>
                {{ currentItem.file_path }}
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <!-- kt khuyến mại -->
    <!-- Hướng dẫn sử dụng -->
    <b-modal id="modal-view-hot-help" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="mt-50 use-new">
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Mục đích: </label>
            <label class="ml-50"> {{ currentItem.purposes }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Đối tượng áp dụng: </label>
            <label class="ml-50"> {{ currentItem.applicable_object }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <!-- eslint-disable vue/no-v-html -->
            <div class="question-content" v-html="currentItem.contents"/>
            <!-- eslint-enable -->
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                         @click="downloadFile(currentItem.file_path)">
            <div class="sample-file__download">
              <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
            </div>
            {{ currentItem.file_path }}
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-50">&nbsp;</b-row>
      <b-row class="text-left mt-50">
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showFeedback(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi đề xuất góp ý
        </b-button>
      </b-row>
    </b-modal>
    <!-- Hướng dẫn sử dụng -->
    <!-- Gửi nội dung feedback -->
    <b-modal id="modal-feedback-hot" scrollable size="xl" title="Gửi ý kiến phản hồi" @ok="handleFeedbackOk">
      <b-row class="mt-50">
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Thuộc: </label>
            <label class="ml-50"> {{ feedbackItem.newName }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <ckeditor id="textarea-auto-height" v-model="feedbackItem.contents" class="editor-form"
                    editor-url="https://cdn.ckeditor.com/4.20.0/full/ckeditor.js"
                    placeholder="Nhập đề xuất của bạn"></ckeditor>
          <!-- <b-form-textarea id="textarea-auto-height" placeholder="Nhập đề xuất của bạn" rows="8"
            v-model="feedbackItem.contents" max-rows="8" /> -->
        </b-col>
        <b-col class="mt-50 text-left" cols="12">
          <div v-if="feedbackItem && feedbackItem.file_path">
            {{ feedbackItem.file_path }}
          </div>
          <b-form-file v-model="feedbackItem.file" accept="application/pdf,application/vnd.ms-excel,application/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain
                       v-on:input="uploadFile">
          </b-form-file>
        </b-col>
      </b-row>

    </b-modal>

    <b-modal id="modal-pack-hot" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="use-new">
        <b-col class="view-left mt-50" cols="4">
          <!-- <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Ngày hiệu lực: </label>
                <label class="ml-50"> {{ currentItem.effect_date }}</label>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban chủ trì: </label>
                <label class="ml-50"> {{ currentItem.department_presiding_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban tham gia: </label>
                <label class="ml-50"> {{ currentItem.department_join_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Người soạn thảo: </label>
                <label class="ml-50"> {{ currentItem.creator_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Người phê duyệt: </label>
                <label class="ml-50"> {{ currentItem.approver }}</label>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mt-50 border-left" cols="8">
          <b-row>
            <b-col class="not-padding-r" cols="4">
              <b-form-group>
                <label class="font-bold">Cước phí: </label>
                <label class="ml-50"> {{ currentItem.postage|number }} vnđ</label>
              </b-form-group>
            </b-col>
            <b-col class="not-padding " cols="4">
              <b-form-group class="border-lr text-center">
                <label class="font-bold">Chu kỳ: </label>
                <label class="ml-50"> {{ currentItem.duration }} ngày</label>
              </b-form-group>
            </b-col>
            <b-col class="not-padding" cols="4">
              <b-form-group style="padding-left: 20px;">
                <label class="font-bold">Gói nền: </label>
                <label class="ml-50"> {{ currentItem.package_daemon }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <!-- eslint-disable vue/no-v-html -->
                <div class="question-content" v-html="currentItem.contents"/>
                <!-- eslint-enable -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Cách đăng ký: </label>
                <label class="ml-50"> {{ currentItem.how_to_register }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Gói bổ sung: </label>
                <label class="ml-50"> {{ currentItem.pack_extra }}</label>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                             @click="downloadFile(currentItem.file_path)">
                <div class="sample-file__download">
                  <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                </div>
                {{ currentItem.file_path }}
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-qa-hot" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="mt-50 use-new">
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Nội dung câu hỏi: </label>
            <label class="ml-50"> {{ currentItem.question }}</label>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <!-- eslint-disable vue/no-v-html -->
            <div class="question-content" v-html="currentItem.answer"/>
            <!-- eslint-enable -->
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                         @click="downloadFile(currentItem.file_path)">
            <div class="sample-file__download">
              <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
            </div>
            {{ currentItem.file_path }}
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-50">&nbsp;</b-row>
      <b-row class="text-left mt-50">
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showFeedback(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi đề xuất góp ý
        </b-button>
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showSMS(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi SMS
        </b-button>
      </b-row>
    </b-modal>
    <!-- Gửi sms -->
    <b-modal id="modal-sms-hot" scrollable size="xl" title="Gửi sms" @ok="handleSMSOk">
      <b-row class="mt-50 ">
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Số điện thoại nhận (iTel)</label>
            <input v-model="smsItem.phone" class="phone-re"
                   maxlength="10"
                   onKeyDown="if(this.value.length==10 && event.keyCode>47 && event.keyCode < 58) return false;" type="number"/>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-textarea id="textarea-auto-height" v-model="smsItem.contents" max-rows="8" placeholder="Nhập nội dung SMS"
                           rows="8"/>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>

import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BFormDatepicker,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import router from "@/router";
import moment from "moment";
import {TypeCategories} from '@/@core/utils/utils';
import {getuserName} from '@/@core/utils/utils';
import "@core/scss/vue/libs/vue-good-table.scss";
import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor, {
  toolbar: [],
  toolbarGroups: []
});

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend
  },

  data() {
    return {
      searchQuery: "",
      listNews: [],
      currentItem: {},
      selected: 0,
      modal_title: "",
      feedbackItem: {},
      emalConfigs: [],
      totalRecords: 0,
      isLoading: false,
      smsItem: {},
      options: {
        fields: [
          {
            field: "catName",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nhóm danh mục",
            required: true
          },
          {
            field: "name",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nội dung",
            required: true
          },
          {
            field: "effect_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày áp dụng",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'dd/MM/yyyy',
            disabled: true
          }
        ]
      },
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 20,
        "lang": 1
      },
    };
  },
  computed: {},
  mounted() {
    this.isSubmit = false;
    this.fetchData();
    this.loadEmailConfig();
  },
  created() {
  },
  watch: {},
  methods: {
    getTitle() {
      return this.modal_title;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.fetchData();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.fetchData();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.fetchData();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.fetchData();
    },

    quickSearch() {
      this.serverParams.columnFilters.searchQuick = this.searchQuery;
      this.fetchData();
    },
    handleOk() {

    },
    fetchData() {
      this.loading(true);
      this.isLoading = true;
      let data = {
        ...this.serverParams,
        columnFilters: {
          ...(this.serverParams.columnFilters ? this.serverParams.columnFilters : [])
        }
      }
      if (data.columnFilters.created_date != undefined) {
        delete data.columnFilters['created_date_']
      }
      useJwt
          .post("portal/HotNews", data)
          .then((response) => {
            if (response.data.code == 200) {
              this.listNews = response.data.result;
              this.totalRecords = response.data.totalRecords;
              this.isLoading = false;
            }
            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    detailClick(row) {
      const id = row.id;
      this.loading(true);
      if (row.cat_type_new == TypeCategories.PACKDATA) {
        useJwt
            .get("portal/getpackdatabyById?id=" + id)
            .then((response) => {
              if (response.data.code == 200) {
                row.isRead = true;
                this.currentItem = response.data.result[0];
                this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
                if (this.currentItem.from_date) {
                  this.currentItem.from_date = this.formatDate(this.currentItem.from_date);
                }
                if (this.currentItem.to_date) {
                  this.currentItem.to_date = this.formatDate(this.currentItem.to_date);
                }
                if (this.currentItem.contents.indexOf('<p>') < 0 && this.currentItem.contents.indexOf("<ul>") < 0 && this.currentItem.contents.indexOf('<li>')) {
                  this.currentItem.contents = '<div class="question-content-break">' + this.currentItem.contents + "</div>";
                }
                this.modal_title = this.currentItem.name;
                this.$bvModal.show("modal-pack-hot");
              }
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      } else if (row.cat_type_new == TypeCategories.QA) {
        useJwt
            .get("portal/getQAbyById?id=" + id)
            .then((response) => {
              if (response.data.code == 200) {
                this.currentItem = response.data.result[0];
                this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
                if (this.currentItem.from_date) {
                  this.currentItem.from_date = this.formatDate(this.currentItem.from_date);
                }
                if (this.currentItem.to_date) {
                  this.currentItem.to_date = this.formatDate(this.currentItem.to_date);
                }
                this.modal_title = this.currentItem.answer;
                if (this.currentItem.answer.indexOf('<p>') < 0 && this.currentItem.answer.indexOf("<ul>") < 0 && this.currentItem.answer.indexOf('<li>') < 0) {
                  this.currentItem.answer = '<div class="question-content-break">' + this.currentItem.answer + "</div>";
                }
                if (this.currentItem.question.indexOf('<p>') < 0 && this.currentItem.question.indexOf("<ul>") < 0 && this.currentItem.question.indexOf('<li>') < 0) {
                  this.currentItem.question = '<div class="question-content-break">' + this.currentItem.question + "</div>";
                }
                if (this.currentItem.reason.indexOf('<p>') < 0 && this.currentItem.reason.indexOf("<ul>") < 0 && this.currentItem.reason.indexOf('<li>') < 0) {
                  this.currentItem.reason = '<div class="question-content-break">' + this.currentItem.reason + "</div>";
                }
                this.$bvModal.show("modal-qa-hot");
              }
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      } else {
        useJwt
            .get("portal/getnewsgroupById?id=" + id)
            .then((response) => {
              if (response.data.code == 200) {
                this.currentItem = response.data.result[0];
                this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
                if (this.currentItem.from_date) {
                  this.currentItem.from_date = this.formatDate(this.currentItem.from_date);
                }
                if (this.currentItem.to_date) {
                  this.currentItem.to_date = this.formatDate(this.currentItem.to_date);
                }
                this.modal_title = this.currentItem.name;
                console.log(this.currentItem.contents);
                if (this.currentItem.contents.indexOf('<p>') < 0 && this.currentItem.contents.indexOf("<ul>") < 0 && this.currentItem.contents.indexOf('<li>')) {
                  this.currentItem.contents = '<div class="question-content-break">' + this.currentItem.contents + "</div>";
                }

                if (this.currentItem.cat_type_new == TypeCategories.POLICY || this.currentItem.cat_type_new == TypeCategories.PROCESS_REGULATIONS) {
                  this.$bvModal.show("modal-view-hot");
                } else if (this.currentItem.cat_type_new == TypeCategories.PROMOTION) {
                  this.$bvModal.show("modal-view-hot-promotion");
                } else if (this.currentItem.cat_type_new == TypeCategories.HELP) {
                  this.$bvModal.show("modal-view-hot-help");
                }
              }
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      }
    },
    isSelected: function (i) {
      return i === this.selected
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    formatDate(v) {
      return moment(v, 'YYYY/MM/DD').format('DD/MM/YYYY')
    },

    async loadEmailConfig() {
      this.loading(true);
      useJwt.get("portal/emailconfig").then((response) => {
        var result = response.data;
        if (result.code == 200) {

          result.result.forEach(item => {
            this.emalConfigs.push(item.email);
          });
        }

        this.isLoading = false;
        this.loading(false);
      });
    },

    showFeedback(itemNew) {
      this.feedbackItem = {};
      this.feedbackItem.new_group_id = itemNew.id;
      this.feedbackItem.newName = itemNew.name;
      this.$bvModal.show("modal-feedback-hot");
    },

    async handleFeedbackOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.feedbackItem.contents || this.feedbackItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung góp ý!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      this.loading(true);
      try {
        const createParams = {
          id: 0,
          new_group_id: this.feedbackItem.new_group_id,
          contents: this.feedbackItem.contents,
          notes: this.feedbackItem.notes,
          created_at: userName,
          emails: this.emalConfigs.join(','),
          newName: this.feedbackItem.newName,
          type: 0
        };
        const res = await useJwt.post("portal/feedback", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-feedback-hot");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới ý kiến phản hồi!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }

      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới ý kiến phản hồi ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    showSMS(itemNew) {
      this.smsItem = {};
      this.smsItem.ref_id = itemNew.id;
      this.smsItem.newName = itemNew.answer;
      this.$bvModal.show("modal-sms-hot");
    },

    async handleSMSOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.smsItem.phone || this.smsItem.phone.trim().length < 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải số điện thoại nhận SMS.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      if (this.smsItem.phone.indexOf('087') != 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải số iTel (bắt đầu bằng 087).",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }

      if (!this.smsItem.contents || this.smsItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung SMS!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      try {
        this.loading(true);
        const createParams = {
          id: 0,
          ref_id: this.smsItem.ref_id,
          contents: this.smsItem.contents.trim(),
          phone: this.smsItem.phone,
          created_at: userName
        };
        const res = await useJwt.post("portal/sms", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-sms-hot");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Gửi sms thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }

      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi gửi sms.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async uploadFile() {
      var formData = new FormData();
      formData.append("file", this.feedbackItem.file);
      this.loading(true);
      const res = await useJwt.post(`portal/upload`, formData);
      if (res.data.code == 200) {
        this.feedbackItem.file_path = res.data.result;
      }
      this.loading(false);
    },
    async downloadFile(filePath) {
      try {
        this.loading(true);
        const downloadParams = {filePath: filePath};
        const arrFile = filePath.replaceAll('\\', '/').split('/');
        const res = await useJwt.postDownload("portal/download", arrFile[1], downloadParams);
        this.loading(false);
        // if (res.status != 200) {
        //   this.$toast({
        //     component: ToastificationContent,
        //     props: {
        //       title: "File không đúng hoặc không còn tồn tại.",
        //       icon: "AlertTriangleIcon",
        //       variant: "danger"
        //     },
        //   });
        // }
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    }
  },
};

</script>
<style lang="css">
.list-group-item:focus,
list-group-item:hover,
button.list-group-item:focus,
button.list-group-item:hover {
  color: #555;
  text-decoration: none;
  background-color: rgb(34 41 47 / 10%) !important;
  cursor: pointer;
}

.list-group-item.active,
.list-group-item.active:focus,
.list-group-item.active:hover {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  cursor: pointer;
}

.list-group-item > span {
  cursor: pointer;
}

#modal-hot-view .modal-dialog, #modal-view-hot-promotion .modal-dialog, #modal-view-hot-help .modal-dialog, #modal-qa-hot .modal-dialog, #modal-pack-hot .modal-dialog {
  width: calc(100% - 560px) !important;
  margin-right: 40px;
  height: 100%;
  max-width: calc(100% - 560px) !important;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}

.use-new label {
  line-height: 50px;
  font-size: 1rem;
}

.border-left {
  border-left: 2px solid #ccc;
}

.phone-re {
  display: inline-block;
  width: 200px;
  margin-left: 20px;
  border: 1px solid #ddd;
  height: 30px;
  border-radius: 3px;
}

input:focus-visible {
  outline: none !important;
  border: 1px solid #ed1f24;
}

.is-read {
  opacity: 0.6;
}

.question-content-break {
  min-height: 330px;
  white-space: break-spaces;
  line-height: 2.5rem;
}

.input-group-merge {
  cursor: pointer;
}

.use-new .vgt-responsive {
  height: calc(100vh - 390px);
  background-color: #fff;
}
</style>
<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
@import "@core/scss/vue/bootstrap-vue/tooltip";
</style>
